// ── what gets asked for, in one place ──────────────────────────────
//
// This was inline in App.jsx. It is out here because the table prototype has to
// send the SAME request: the Medium axis compares a screen session with a table
// session and its whole premise is that only the medium differs. Two copies of
// this expression drifting by a newline would put that difference inside the
// prompt, where nothing would ever report it.
//
// It is the same reason readingCacheKey already lives on its own — a request
// and the key that identifies it have to be functions of the same thing.
//
// The rule the ordering exists for (2-1): the reading is built from CONTENT
// ONLY. No coordinates, no resonance, no move counts, and no ordering derived
// from any of them. Sorting by id rather than by resonance is part of that —
// sorting by a spatial value smuggles the arrangement into the prompt through
// the sequence itself.
//
// Extracted under v6.1.1 and pinned: scripts/verify-reading-request.mjs holds
// the bytes the inline version produced, generated from a verbatim copy of it
// BEFORE this file existed. If this function is ever changed, that test fails
// and the question becomes whether every session recorded under the old bytes
// is still comparable — which is the question it exists to force.

export function buildReadingContent(frags, lens, { readImages = false } = {}) {
  const forReading = [...frags]
    .filter(f => readImages || f.type !== "image")
    .sort((a, b) => (a.id < b.id ? -1 : a.id > b.id ? 1 : 0))
    .map(f => ({ id: f.id, text: f.named ? f.text : "" }));
  const hasUnnamed = forReading.some(f => !f.text);
  const content = [{ type: "text", text: `Fragments:\n${JSON.stringify(forReading)}` }];
  if (readImages) {
    frags.filter(f => f.type === "image" && f.imageBase64).forEach(f => {
      content.push({ type: "image", source: { type: "base64", media_type: f.imageType, data: f.imageBase64 } });
      content.push({ type: "text", text: `(image fragment id ${f.id})` });
    });
  }
  const lensCtx = `\nActive lens: ${lens}. ${lens === "TENSION" ? "Focus on conflicts, contrasts, and friction between fragments." : "Focus on recurring patterns across fragments."}`;
  content.push({ type: "text", text: `${lensCtx}${hasUnnamed ? "\nSome fragments have no text. Describe them by their relation to the others; do NOT give them names." : ""}\nJSON only.` });
  return { forReading, content };
}
